import { BoolQueryParam } from '../../../common/api/Query'

export interface ScriptExecutionInmunocomDTO {
  id: string
  date: Date
  clinicID: string
  userID: string
  success: boolean
  summaryFileID: string
  sequenceFileID: string
  alignmentFileID: string
  cobertureFileID: string
  zipFileID: string
}

export class ScriptExecutionInmunocom {
  private readonly _id: string
  private readonly _date: Date
  private readonly _clinicID: string
  private readonly _userID: string
  private readonly _success: boolean
  private readonly _summaryFileID: string
  private readonly _sequenceFileID: string
  private readonly _alignmentFileID: string
  private readonly _cobertureFileID: string
  private readonly _zipFileID: string

  constructor(p: ScriptExecutionInmunocomDTO) {
    this._id = p.id
    this._date = p.date
    this._clinicID = p.clinicID
    this._userID = p.userID
    this._success = p.success
    this._summaryFileID = p.summaryFileID
    this._sequenceFileID = p.sequenceFileID
    this._alignmentFileID = p.alignmentFileID
    this._cobertureFileID = p.cobertureFileID
    this._zipFileID = p.zipFileID
  }

  get id(): string {
    return this._id
  }

  get date(): Date {
    return this._date
  }

  get clinicID(): string {
    return this._clinicID
  }

  get userID(): string {
    return this._userID
  }

  get success(): boolean {
    return this._success
  }

  get summaryFileID(): string {
    return this._summaryFileID
  }

  get sequenceFileID(): string {
    return this._sequenceFileID
  }

  get alignmentFileID(): string {
    return this._alignmentFileID
  }

  get cobertureFileID(): string {
    return this._cobertureFileID
  }

  get zipFileID(): string {
    return this._zipFileID
  }

  toDTO(): ScriptExecutionInmunocomDTO {
    return {
      id: this.id,
      date: this.date,
      clinicID: this.clinicID,
      userID: this.userID,
      success: this.success,
      summaryFileID: this.summaryFileID,
      sequenceFileID:   this.sequenceFileID,
      alignmentFileID:   this.alignmentFileID,
      cobertureFileID:   this.cobertureFileID,
      zipFileID: this.zipFileID,
    }
  }
}

export function toModel(d: ScriptExecutionInmunocomDTO): ScriptExecutionInmunocom {
  return new ScriptExecutionInmunocom(d)
}

export interface ScriptExecutionInmunocomQuery {
  date: Date
  success: BoolQueryParam
}